import React from "react";
import RightButton from "./RightButton";
import RightCategories from "./RightCategories";
import RightRecentNews from "./RightRecentNews";

const RightAboutSection1 = () => {
  return (
    <div className="right mx-6 lg:w-[30%]">
      <div className="">
        <h1 className="mt-10 text-3xl font-medium"> MEANING OF SCHOOL</h1>
        <hr className="mt-4 border-black" />
        <ul className=" mt-8 space-y-3  text-xl text-gray-800 lg:mr-72 lg:w-full ">
          <RightCategories title="Student" />
          <RightCategories title="Come" />
          <RightCategories title="Here to" />
          <RightCategories title="Obtain" />
          <RightCategories title="Objective of" />
          <RightCategories title="Learning" />
        </ul>
      </div>

      <div className="mt-8">
        <h1 className="text-3xl font-medium">THOUGHTS</h1>
        <hr className="mt-4 border-black" />
        <ul className=" mt-8 space-y-3  text-xl text-gray-800  ">
          <RightCategories title="Make yourself strong" />
          <RightCategories title="Be brave and face the world" />
          <RightCategories title="Knowledge is like a treasure" />
          <RightCategories title="Be smart and speak less." />
          <RightCategories title="Educate yourself if you want to change the world." />
          <RightCategories title="Don't lose hope due to failures." />
        </ul>
      </div>

      <div className="mt-8">
        <h1 className="text-3xl font-medium">UPDATE</h1>
        <hr className="mt-4 border-black" />
        <ul className="space-y-3 text-xl text-gray-800">
          <RightRecentNews
            news="Examination will start on"
            date="end of this month"
          />
          <RightRecentNews
            news="Result will be announced on"
            date="soon"
          />
          <RightRecentNews news="PTM conducted on " date="last saturday of every month" />
        </ul>
      </div>

      <div className="mt-8">
        <h1 className="text-3xl font-medium">Tags</h1>
        <hr className="mt-4 border-black" />
        <div className="mt-8 space-y-3 text-lg">
          <RightButton tags="#student" />
          <RightButton tags="#success" />
          <RightButton tags="#career" />
          <RightButton tags="#education" />
          <RightButton tags="#aim" />
          <RightButton tags="#share" />
          <RightButton tags="#socialmedia" />
          <RightButton tags="#school" />
          <RightButton tags="#teacher" />
          <RightButton tags="#wisdom" />
          <RightButton tags="#consistency" />
        </div>
      </div>
    </div>
  );
};

export default RightAboutSection1;
